export const SET_ACTIVETAB = 'SET_ACTIVETAB'
export const CLEAR_ACTIVETAB = 'CLEAR_ACTIVETAB'
